/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SourceDto } from '../models/source-dto';

@Injectable({
  providedIn: 'root',
})
export class SourcesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadSources
   */
  static readonly LoadSourcesPath = '/sources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadSources()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadSources$Response(params?: {

  }): Observable<StrictHttpResponse<Array<SourceDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SourcesService.LoadSourcesPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SourceDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadSources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadSources(params?: {

  }): Observable<Array<SourceDto>> {

    return this.loadSources$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SourceDto>>) => r.body as Array<SourceDto>)
    );
  }

}
